import { render } from "./S140026.vue?vue&type=template&id=16ddc3a6"
const script = {}
script.render = render

export default script